import { TIconProps } from './utils';

export const ArrowFilterIcon = ({ className = '' }: TIconProps) => (
  <svg
    width='27'
    height='27'
    viewBox='0 0 27 27'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M19.6035 16.869C19.4058 17.0825 19.0682 17.0827 18.8702 16.8694L14.5994 12.2685C14.0059 11.6292 12.9941 11.6292 12.4006 12.2685L8.12975 16.8694C7.93178 17.0827 7.59422 17.0825 7.39648 16.869L6.99624 16.4369C6.81867 16.2452 6.81867 15.9491 6.99624 15.7574L13.1332 9.13182C13.3311 8.91818 13.6689 8.91818 13.8668 9.13182L20.0038 15.7574C20.1813 15.9491 20.1813 16.2452 20.0038 16.4369L19.6035 16.869Z'
      fill='#A3A3A3'
      stroke='#A3A3A3'
    />
  </svg>
);
